import { ColDef } from 'ag-grid-community';
import { DefaultCellTooltip } from 'components/grids/tooltip/DefaultCellTooltip';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import checkIcon from 'components/asset/UnChecked.svg';

// 인물검색(복수) - 전체 목록 grid
export const useColumnDefsForSearchPerson = () => {
  const { t } = useTranslation();
  const defaultColDef = useMemo((): ColDef => {
    return {
      sortable: false,
      resizable: true,
      cellStyle: { textAlign: 'center' },
      // flex: 1,
      tooltipComponent: DefaultCellTooltip,
    };
  }, []);

  const colDefs = useMemo((): any[] => {
    return [
      {
        headerName: 'check',
        headerComponentParams: {
          template: `<img src=${checkIcon} alt=''/>`,
        },
        width: '28px',
        height: 24,
        padding: '2px 6px',
        resizable: false,
        headerCheckboxSelection: true,
        showDisabledCheckboxes: true,
        checkboxSelection: true,
        cellStyle: {
          display: 'flex',
          justifyContent: 'center',
          width: '28px',
          height: 24,
        },
      },
      {
        headerName: t('이름', '__이름'),
        field: 'empNm',
        tooltipField: 'empNm',
        flex: 1,
      },
      {
        headerName: t('직책/직급', '__직책/직급'),
        field: 'jtiNm',
        tooltipField: 'jtiNm',
        flex: 1,
      },
      {
        headerName: t('부서', '__부서'),
        field: 'deptNm',
        tooltipField: 'deptNm',
        flex: 1,
      },
    ];
  }, []);

  const handleAprvDetailBtn = (data) => {
    console.log('화면 연결이 필요합니다.');
  };

  return { defaultColDef, colDefs };
};
